"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadows = exports.maxPageWidth = exports.minTapTarget = exports.breakpoints = exports.aspectRatios = exports.spacing = exports.borderRadius = exports.colors = void 0;
const merge_1 = __importDefault(require("@treefort/lib/merge"));
const alias_1 = __importDefault(require("./alias"));
const global_1 = __importDefault(require("./global"));
// "base" tokens are all tokens except for component tokens (i.e. alias, global,
// and typography tokens merged together)
_a = (0, merge_1.default)(alias_1.default, global_1.default), exports.colors = _a.colors, exports.borderRadius = _a.borderRadius, exports.spacing = _a.spacing, exports.aspectRatios = _a.aspectRatios, exports.breakpoints = _a.breakpoints, exports.minTapTarget = _a.minTapTarget, exports.maxPageWidth = _a.maxPageWidth, exports.shadows = _a.shadows;
